<template>
    <div class="card p-5 card-3 card-notifier" >
        <div class="card-body text-a-c" style="padding: 0;">
            <div class="card-icon-notifier" :style="iconStyle">
                <i :class="iconType"></i>
            </div>
            <h5>{{title}}</h5>
            <p class="card-text">
                {{message}}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'type',
            'title',
            'message'
        ],
        data: function() {
            let icon = 'fas fa-exclamation-triangle';
            let style='color:#f7ba58';
            if(this.type === "error") {icon = 'fas fa-exclamation-circle'; style='color:#c85740'}
            else if(this.type === "info") {icon = 'fas fa-info-circle';style='color:#2d84bd'}
            return {
                iconType: icon,
                iconStyle: style
            }
        }
    }
</script>

<style scoped>
    .card-notifier{
        margin: 50px auto;
        width: 100%;
        max-width: 360px;
    }

    .card-notifier h5{
        margin-top: 10px;
    }

    .card-notifier .card-icon-notifier{
        display: flex;
        justify-content: center;
        font-size: 50px;
        color: #c3c3c3;
    }
</style>